import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useGame } from "../context/GameContext";
import TopBar from "../components/TopBar";
import { speak } from "../lib/speech";
import { sound } from "../lib/sounds";
import { Music, Volume2, Mic, Type, Contrast, Zap, RefreshCw } from "lucide-react";
import { Switch } from "../components/ui/switch";

const Row = ({ icon: Icon, label, desc, checked, onChange, testid }) => (
  <div className="flex items-center gap-4 rounded-3xl bg-white p-4 shadow-md">
    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-50 text-sky-500"><Icon className="h-6 w-6" /></div>
    <div className="flex-1">
      <p className="font-display text-lg font-bold text-slate-800">{label}</p>
      <p className="text-xs font-bold text-slate-400">{desc}</p>
    </div>
    <Switch data-testid={testid} checked={checked} onCheckedChange={onChange} />
  </div>
);

export default function Settings() {
  const { profile, updateSettings, clearActive } = useGame();
  const navigate = useNavigate();
  useEffect(() => { const t = setTimeout(() => speak("Hier kun je alles instellen."), 400); return () => clearTimeout(t); }, []);
  if (!profile) return null;
  const s = profile.settings || {};
  const set = (key) => (val) => { sound.tap(); updateSettings({ [key]: val }); };

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-100 to-emerald-50">
      <TopBar title="Instellingen" />
      <div className="mx-auto max-w-lg px-4 pb-16 pt-4 space-y-3">
        <h2 className="font-display text-lg font-bold text-slate-500">Geluid</h2>
        <Row testid="setting-music" icon={Music} label="Muziek" desc="Rustige achtergrondmuziek" checked={s.music !== false} onChange={set("music")} />
        <Row testid="setting-sfx" icon={Volume2} label="Geluidseffecten" desc="Ding, applaus en pop" checked={s.sfx !== false} onChange={set("sfx")} />
        <Row testid="setting-voice" icon={Mic} label="Voorlezen" desc="Luna leest alles voor" checked={s.voice !== false} onChange={set("voice")} />

        <h2 className="pt-2 font-display text-lg font-bold text-slate-500">Toegankelijkheid</h2>
        <Row testid="setting-dyslexia" icon={Type} label="Dyslexie-lettertype" desc="Makkelijker te lezen" checked={!!s.dyslexia} onChange={set("dyslexia")} />
        <Row testid="setting-contrast" icon={Contrast} label="Hoog contrast" desc="Fellere kleuren" checked={!!s.highContrast} onChange={set("highContrast")} />
        <Row testid="setting-motion" icon={Zap} label="Minder beweging" desc="Rustigere animaties" checked={!!s.reduceMotion} onChange={set("reduceMotion")} />

        <motion.button
          data-testid="switch-player-btn" whileTap={{ scale: 0.97 }}
          onClick={() => { clearActive(); navigate("/"); }}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-3xl bg-white p-4 font-display font-bold text-slate-600 shadow-md"
        >
          <RefreshCw className="h-5 w-5" /> Wissel speler
        </motion.button>
      </div>
    </div>
  );
}
